import { render, staticRenderFns } from "./allGradesComparison_week.vue?vue&type=template&id=c57586de&scoped=true&"
import script from "./allGradesComparison_week.vue?vue&type=script&lang=js&"
export * from "./allGradesComparison_week.vue?vue&type=script&lang=js&"
import style0 from "./allGradesComparison_week.vue?vue&type=style&index=0&id=c57586de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57586de",
  null
  
)

export default component.exports